// # services
import { auth } from "@/services";

(function (angular) {
  "use strict";

  angular
    .module("app")
    .controller(
      "notificationsDropdownController",
      notificationsDropdownController,
    );

  notificationsDropdownController.$inject = ["notificationsApi"];

  function notificationsDropdownController(notificationsApi) {
    const vm = this;
    vm.markAsRead = markAsRead;

    function getNotifications() {
      // Handle the api call response - saves the response to notifications variable
      const handleNotificationsResponse = (response) => {
        vm.notifications = response.data.slice(0, 5);
      };

      notificationsApi.get(
        {
          id: null,
          type: null,
          notifiable_id: null,
          created_at_from: null,
          created_at_to: null,
          read: null,
          sort: "created_at",
          order: "desc",
        },
        handleNotificationsResponse,
      );
    }

    function markAsRead(notification) {
      notificationsApi.post({
        id: [notification.id],
      });

      getNotifications();
    }

    getNotifications();
  }
})(angular);
